// This file was auto-generated by Fern from our API Definition.
export var CatalogMedia;
(function (CatalogMedia) {
    CatalogMedia.Kind = {
        Image: "image",
        Video: "video",
    };
})(CatalogMedia || (CatalogMedia = {}));
